import { PlusIcon } from 'lucide-react'
import clsx from 'clsx'

export function CollectionTemplateTableFooter () {
  return (
    <div className="flex items-center w-full justify-between h-8 min-h-8 -mt-[1px] bg-base-100 border-t border-neutral/40 sticky bottom-0">
      <div className={clsx(
        'hover:bg-base-200',
        'text-gray-600',
        'h-full',
        'px-4',
        'grow',
        'text-sm',
        'flex',
        'items-center',
        'cursor-pointer',
        'min-h-6'
      )}
      >
        <div className="flex gap-1.5 items-center text-xs">
          <PlusIcon size={13} />
          New record
        </div>
      </div>
    </div>
  )
}
